import { Col, PositionLink, Row, Tag } from "@/components";
import { HeadingLevel } from "@/types/headings";
import { useEffect, useRef, useState } from "react";
import "./CardMap.scss";

type CardMapProps = {
  id: string;
  title: string;
  titleTag: HeadingLevel;
  href?: string;
  description?: string;
  showGoToLabel?: boolean;
  goToLabel?: string;
  isExternal?: boolean;
  showIcon?: boolean;
  asLink?: "a";
  className?: string;
  plainAddress?: string;
  setSelectedCard?: (id: string) => void;
  addressLabel?: string;
  addressLabelTitleTag?: HeadingLevel;
};
export const CardMap = ({
  id,
  title,
  titleTag: TitleTag = "h2",
  href,
  description,
  isExternal = false,
  asLink = "a",
  className,
  plainAddress,
  showGoToLabel = false,
  goToLabel = "Indicazioni",
  setSelectedCard = () => { },
  addressLabel = "Indirizzo",
  addressLabelTitleTag: AddressLabelTitleTag = "h3",
}: CardMapProps) => {
  const LinkComponent = asLink;
  const [isActive, setIsActive] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsActive(false);
      }
    };

    if (isActive) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isActive]);
  return (
    <Col
      as={"div"}
      justifyContent={"center"}
      ref={dropdownRef}
      br={"x4"}
      p={"x24"}
      bg={"white"}
      className={`${className} ${isActive ? "ui-is-active" : "ui-card-search"} shadow cursor-pointer text-slate-28`}
      onClick={() => {
        setIsActive(true);
        setSelectedCard(id);
      }}
    >
      <Col pb={"x24"}>
        <TitleTag className="flex-1">
          <LinkComponent
            className={"text-decoration-none fs-4 text-primary fw-semibold"}
            href={href}
            target={isExternal ? "_blank" : undefined}
            rel={isExternal ? "noreferrer noopener" : undefined}
          >
            {title}
          </LinkComponent>
        </TitleTag>
        {description && (
          <Row flexWrap="wrap" gap="x8" py="x8">
            <Tag label={description} className="ui-card-map-tag" />
          </Row>
        )}
      </Col>

      {plainAddress && (
        <Col as={"footer"} gap={"x8"} bg={"white"}>
          <AddressLabelTitleTag className={"fw-semibold fs-6"}>
            {addressLabel}
          </AddressLabelTitleTag>
          <p className={"fw-regular"}>{plainAddress}</p>
        </Col>
      )}
      {showGoToLabel && goToLabel && href && (
        <Col as={"footer"} bg={"white"} alignItems={"end"} pt={"x16"}>
          <PositionLink href={href} isExternal={isExternal} iconPosition="left">
            {goToLabel.toUpperCase()}
          </PositionLink>
        </Col>
      )}
    </Col>
  );
};
